import _ from 'lodash';
import { mergeWithDefaults } from '@src/emp-3.0/utils';
import { useDefaultErrorEventIds } from '@src/emp-3.0/hooks';
import { useCallback, useMemo } from 'react';
import { EWithinUnitType } from '@src/emp-3.0/types';

export const useBuildFlowFormData = () => {
  const { errorEventIds } = useDefaultErrorEventIds();
  const defaultFlowObj = useMemo(() => {
    return {
      name: undefined,
      description: undefined,
      definition: {
        events: {
          start_event: undefined,
          success_event: undefined,
          without_event: undefined,
          error_event: [...errorEventIds],
        },
        settings: {
          distribution: {
            min: undefined,
            max: undefined,
          },
          threshold: {
            t1: undefined,
            t2: undefined,
          },
          timeout: undefined,
          timeout_unit: 'seconds',
          complete_timeout: 60,
          complete_timeout_unit: EWithinUnitType.MINUTE,
        },
        network_request_patterns: [],
        flow_sql_definition: undefined,
        pairing_logic: 'first_first',
        propagative_dimensions: [],
      },
      keep_historical: 1,
      journey_stage: '',
      labels: [],
    };
  }, [errorEventIds]);

  const buildFlowFormData = useCallback(
    (flow?: any) => {
      const cleaned = mergeWithDefaults(flow, defaultFlowObj);
      return _.cloneDeep(cleaned);
    },
    [defaultFlowObj],
  );

  return { buildFlowFormData };
};
